import { RoutePath } from 'enums/routePath';

const ROOT = `/settings`;
const SETTING_BILLING = `${ROOT}/billing`;
const SETTING_FIELDS = `${ROOT}/fields`;
const SETTING_FIELDS_COMPANY = `${SETTING_FIELDS}/company`;
const SETTING_FIELDS_CONTACTS = `${SETTING_FIELDS}/contacts`;
const SETTING_ACCOUNT_VISIBILITY = `${ROOT}/account/visibility`;
const SETTING_RECURRING_MEETINGS = `${ROOT}/integration/recurring-meetings`;
const SETTING_INVOICES = `${ROOT}/invoices`;
const SETTING_IMPORT = `${ROOT}/import`;
const SETTING_O365 = `${ROOT}/integration/office365`;
const SETTING_PSA_INTEGRATION = `${ROOT}/integration/psa-integration`;
const SETTING_TEAMS_CALLING = `${ROOT}/integration/teamscalling`;
const SETTING_SCORING = `${ROOT}/scoring`;
const SETTING_FILE_SHARE = `${ROOT}/fileshare`;
const SETTING_USER = `${ROOT}/user/:id`;
const SETTING_USERS = `${ROOT}/users`;
const SETTING_ASSIGNED_ACCOUNTS = `${ROOT}/assigned-accounts`;
const SETTING_COMPANY_USER_MAPPING = `${ROOT}/company-user-mapping`;
const SETTING_COMMUNICATION_PREFERENCES = `${ROOT}/communication-preferences`;
const SETTING_AGREEMENT_TYPE_INCLUSIONS = `${ROOT}/agreement-type-inclusions`;
const SETTING_ACCOUNT_CURRENCY = `${ROOT}/account-currency`;
const SETTING_MEETING_PLANNER_TIERS = `${ROOT}/account-tiering-settings`;
const SETTING_FEATURE_SELECTION = `${ROOT}/feature-selection`;
const SETTING_PRODUCT_STACK_SETUP = `${ROOT}/product-stack-setup`;

export const settingPaths = {
  [RoutePath.SETTING_ACCOUNT_CURRENCY]: SETTING_ACCOUNT_CURRENCY,
  [RoutePath.SETTING_BILLING]: SETTING_BILLING,
  [RoutePath.SETTING_FIELDS]: SETTING_FIELDS,
  [RoutePath.SETTING_FIELDS_COMPANY]: SETTING_FIELDS_COMPANY,
  [RoutePath.SETTING_FIELDS_CONTACTS]: SETTING_FIELDS_CONTACTS,
  [RoutePath.SETTING_ACCOUNT_VISIBILITY]: SETTING_ACCOUNT_VISIBILITY,
  [RoutePath.SETTING_RECURRING_MEETINGS]: SETTING_RECURRING_MEETINGS,
  [RoutePath.SETTING_INVOICES]: SETTING_INVOICES,
  [RoutePath.SETTING_IMPORT]: SETTING_IMPORT,
  [RoutePath.SETTING_O365]: SETTING_O365,
  [RoutePath.SETTING_PRODUCT_STACK_SETUP]: SETTING_PRODUCT_STACK_SETUP,
  [RoutePath.SETTING_PSA_INTEGRATION]: SETTING_PSA_INTEGRATION,
  [RoutePath.SETTING_TEAMS_CALLING]: SETTING_TEAMS_CALLING,
  [RoutePath.SETTING_SCORING]: SETTING_SCORING,
  [RoutePath.SETTING_FILE_SHARE]: SETTING_FILE_SHARE,
  [RoutePath.SETTING_USER]: SETTING_USER,
  [RoutePath.SETTING_USERS]: SETTING_USERS,
  [RoutePath.SETTING_ASSIGNED_ACCOUNTS]: SETTING_ASSIGNED_ACCOUNTS,
  [RoutePath.SETTING_COMPANY_USER_MAPPING]: SETTING_COMPANY_USER_MAPPING,
  [RoutePath.SETTING_COMMUNICATION_PREFERENCES]:
    SETTING_COMMUNICATION_PREFERENCES,
  [RoutePath.SETTING_AGREEMENT_TYPE_INCLUSIONS]:
    SETTING_AGREEMENT_TYPE_INCLUSIONS,
  [RoutePath.SETTING_MEETING_PLANNER_TIERS]: SETTING_MEETING_PLANNER_TIERS,
  [RoutePath.SETTING_FEATURE_SELECTION]: SETTING_FEATURE_SELECTION,
};

export const settingsPaths = {
  [RoutePath.SETTINGS]: ROOT,
};

const paths = {
  ...settingsPaths,
  ...settingPaths,
};

export const pathArray = Object.values(paths);

export default paths;
